"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const isArray_1 = tslib_1.__importDefault(require("lodash/fp/isArray"));
const isEmpty_1 = tslib_1.__importDefault(require("lodash/fp/isEmpty"));
const CustomState_1 = tslib_1.__importDefault(require("./CustomState"));
const NotBookedState = (props) => {
    const { message, features, icon = 'rioglyph-stars' } = props, remainingProps = tslib_1.__rest(props, ["message", "features", "icon"]);
    const combinedMessages = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [message && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'text-medium margin-bottom-20' }, { children: message })), features && (0, isArray_1.default)(features) && !(0, isEmpty_1.default)(features) && ((0, jsx_runtime_1.jsx)("ul", Object.assign({ className: 'feature-list' }, { children: features.map((feature, index) => ((0, jsx_runtime_1.jsx)("li", { children: feature }, index))) })))] }));
    return (0, jsx_runtime_1.jsx)(CustomState_1.default, Object.assign({ message: combinedMessages, icon: icon }, remainingProps));
};
exports.default = NotBookedState;
